import { render } from "./PronosticoEditar.vue?vue&type=template&id=8c22ccb2&scoped=true"
import script from "./PronosticoEditar.vue?vue&type=script&lang=js"
export * from "./PronosticoEditar.vue?vue&type=script&lang=js"

import "./PronosticoEditar.vue?vue&type=style&index=0&id=8c22ccb2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c22ccb2"]])

export default __exports__